import { ReactElement } from 'react';
import { generatePath, Navigate, Outlet } from 'react-router-dom';
import { EAppRoutes, Permission } from '@common/enums';
import { useAuthContextProvider } from '@common/hooks/auth/AuthContextProvider';

interface IAuthGuardProps {
  permission: Permission;
}

/**
 * Common guard to check if user is authenticated and has module permission, otherwise redirect to home
 * @param permission - permission type
 * @constructor
 */
export const AuthAndPermissionGuard = ({ permission }: IAuthGuardProps): ReactElement => {
  const authContext = useAuthContextProvider();

  if (!authContext.checkAuthAndPermissions(permission)) {
    return <Navigate to={generatePath(authContext.isAuthenticated ? EAppRoutes.Reporting : EAppRoutes.Home)} />;
  }

  return <Outlet />;
};
